import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RequestModel } from '../typings/typing';
import { BehaviorSubject, Observable, Subject  } from 'rxjs';
import { UserData } from '../models/userData.model';
import { Router } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from 'src/app/services/sharedDataService.service';
import { CustomerService } from './customer.service';
import { GlobalService } from 'src/app/services/global-service.service';

@Injectable({
  providedIn: 'root'
})

export class LoginService {
  prefix = '/eshop_backend';
  orgRoutes:any;
  // Home Page Privacy Agree Status
  private hasAgreeAllPrivacy = new Subject<boolean>();
  // Userinfo disabled / pending
  private isAgreePendingStatus = new Subject<boolean>();


  private userDataSubject: BehaviorSubject<UserData | null>;
  public userData$: Observable<UserData | null>;

  constructor(private http: HttpClient, private router: Router, private message: NzMessageService, private translate: TranslateService, private customerService: CustomerService,
    private sharedData: SharedDataService, private globalService: GlobalService
  ) {
    const storedUserData = localStorage.getItem('userData');
    this.userDataSubject = new BehaviorSubject<UserData | null>(storedUserData ? JSON.parse(storedUserData) : null);
    this.userData$ = this.userDataSubject.asObservable();
  }

  getRoleList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/roleQuery/getRolePageInfo', { params: params }, { headers });
  }

  getOrgList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/orgConfig/page', { params: params }, { headers });
  }

  getToken(params: any) {
    const headers = new HttpHeaders().set('isUserCenter', 'true');
    this.http.get<any>('/ciam/loginRedirectUrl', { params: params, headers: headers }).subscribe(result => {
      if (result.code == 200) {
        let data = result.data;
        localStorage.setItem('userData', JSON.stringify(data));
        localStorage.setItem('token', data.token);
        this.globalService.setGlobalVariable(true);
        this.userDataSubject.next(data)
        //get sales org
        const salesOrgVOList = data?.salesOrgVOList;
        this.getOrgList({pageNum:1,pageSize:-1}).subscribe(res => {
          const orgList = res.data.records;
          this.orgRoutes = orgList.reduce((acc:any, item:any) => {
            const key = `${item.salesOrganization}-${item.distributionChannel}-${item.division}`;
            acc[key] = `${item.router}`;
            return acc;
          }, {});
          const result = orgList.reduce((acc:any, item:any) => {
            const key = item.router;
            const orgKey = `${item.salesOrganization}-${item.distributionChannel}-${item.division}`;
            if (!acc[key]) {
              acc[key] = [];
            }

            if (!acc[key].includes(orgKey)) {
              acc[key].push(orgKey);
            }

            return acc;
          }, {});
          localStorage.setItem('allOrgRoutes', JSON.stringify(result));
          this.goDefaultPage(salesOrgVOList, data);
        })
      } else {
        this.userDataSubject.next(null);
      }
    })
  }

  goDefaultPage(salesOrgVOList: any, data: any) {
    const hasHomepagePermission = data?.queryUserPageInfoResDTO?.hasHomepagePermission;
    const loginStatus = data?.queryUserPageInfoResDTO?.status
    const defaultUrl = (hasHomepagePermission && loginStatus === 2) ? '/homepage' : '/home/index';
    if(window.location.href.includes("Salesportal/iam/cart/gettoken")) {
      this.router.navigate(['iam/cart']);
      return;
    }
    const uniqueOrgKeys = salesOrgVOList.map((org: { salesOrganization: any; distributionChannel: any; division: any; }) => {
      const orgKey = `${org.salesOrganization}-${org.distributionChannel}-${org.division}`;
      return orgKey;
    });
    localStorage.setItem('sales_org', JSON.stringify(uniqueOrgKeys));

    if(localStorage.getItem('country')){
      this.router.navigate([localStorage.getItem('country') + defaultUrl])
      .then(success => {
        if (success) {
          this.customerService.init();
        }
      });
      return;
    }
    let targetRoute = '';
    // Routing logic
    if (uniqueOrgKeys.includes('CN20-G1-40') || uniqueOrgKeys.size === 0) {
      targetRoute = this.orgRoutes['CN20-G1-40'];
      localStorage.setItem('country', targetRoute);
    }else {
      const iamKeys = Object.keys(this.orgRoutes).filter(key => this.orgRoutes[key] === '/iam');
      const hasIAM = iamKeys.some(key => uniqueOrgKeys.includes(key));
      if(hasIAM){
        targetRoute = '/iam';
      }else{
        const firstOrgKey = uniqueOrgKeys[0];
        targetRoute = this.orgRoutes[firstOrgKey] || '/iam';
      }
      localStorage.setItem('country', targetRoute);
    }
    const fullTargetRoute = targetRoute + defaultUrl;
    this.router.navigate([fullTargetRoute]).then(success => {
      if (success && (fullTargetRoute.includes('/iam') || fullTargetRoute.includes('/oes'))) {
        this.customerService.init();
      }
    });
  }

  /// get customer info by org or soldto name or soldto code
  getCustomerByOrg(params:any){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/masterData/customer/relation', params, { headers });
  }
  getCurrency(){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/masterData/currency', {}, { headers });
  }

  setUserData(userData: UserData | null): void {
    localStorage.setItem('userData', JSON.stringify(userData));
    this.userDataSubject.next(userData);
  }
  logout(params: any) {
    const headers = new HttpHeaders().set('isUserCenter', 'true');
    return this.http.get<any>('/ciam/logout', { params: params, headers: headers });
  }
  getMenuList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    headers.set('globalLoading', 'true');
    return this.http.get<RequestModel>('/menuQuery/userMenuTreeQuery', { params, headers });
  }
  //organization
  getOrganizationList() {
    return this.http.get<RequestModel>(this.prefix + '/shippingAddress/list');
  }
  // set as default
  setAsDefault(params: any) {
    return this.http.post<any>(this.prefix + '/shippingAddress/setdefault', params);
  }
  // sold to list ---> table list
  getSoldToList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/masterData/customer/relation', params, { headers });
  }
  getshipAsDefault(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/customerType/setdefault', params, {headers});
  }
  // Bill Payer Ship List ---> table list
  getBillPayerShipList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.get<any>('/masterData/customer/relation', { params, headers });
  }
  // CH3 ---> table list
  getCH3List() {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/masterData/ch3', { }, { headers});
  }

  // privacy list
  getPrivacyList(){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/privacy/list', { }, { headers });
  }
  // update privacy data
  updatePrivacy(params: any){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/privacy/addOrUpdate', params, { headers } );
  }


  sendAgreeStatus(message: boolean) {
    this.hasAgreeAllPrivacy.next(message);
  }

  getAgreeStatus(): Subject<any> {
    return this.hasAgreeAllPrivacy;
  }

  sendUserPendingStatus(message: boolean) {
    this.isAgreePendingStatus.next(message);
  }

  getUserPendingStatus(): Subject<any> {
    return this.isAgreePendingStatus;
  }

  /**  banner management */
  getBannerTableList(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<RequestModel>('/banner/page', params, { headers });
  }

  signinSSO(params: any) {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    this.http.post<RequestModel>('/user/sales/web/sso/login', params, { headers }).subscribe(result => {
      if (result.code == 200) {
        let data = result.data;
        localStorage.setItem('userData', JSON.stringify(data));
        localStorage.setItem('token', data.token);
        this.globalService.setGlobalVariable(true);
        this.userDataSubject.next(data)
        //get sales org
        const salesOrgVOList = data?.salesOrgVOList;
        this.getOrgList({pageNum:1,pageSize:-1}).subscribe(res => {
          const orgList = res.data.records;
          this.orgRoutes = orgList.reduce((acc:any, item:any) => {
            const key = `${item.salesOrganization}-${item.distributionChannel}-${item.division}`;
            acc[key] = `${item.router}`;
            return acc;
          }, {});
          const result = orgList.reduce((acc:any, item:any) => {
            const key = item.router;
            const orgKey = `${item.salesOrganization}-${item.distributionChannel}-${item.division}`;
            if (!acc[key]) {
              acc[key] = [];
            }
            if (!acc[key].includes(orgKey)) {
              acc[key].push(orgKey);
            }
            return acc;
          }, {});
          localStorage.setItem('allOrgRoutes', JSON.stringify(result));
          this.goDefaultPage(salesOrgVOList, data);
        })
      } else {
        this.userDataSubject.next(null);
      }
    });
  }

  getValidNotice(params:any){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<RequestModel>('/notice/listValidNotice', params, {headers});
  }

  getValidPopupWindows(){
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.post<any>('/popupWindow/listActive', { }, { headers });
  }

  getImageById(id: string): Observable<Blob> {
    const headers = new HttpHeaders().set('isUserCenterAdmin', 'true');
    return this.http.get(`/file/download/${id}`, { headers, responseType: 'blob'});
  }
}

